import { Outlet, useLocation } from "react-router-dom";
import logo from '../../../assets/images/auth-logo.svg';
import './authentication.scss';

export default function AuthenticationLayout() {
    const location = useLocation();
    
    return (
        <section className={`auth-container ${location.pathname.endsWith('/auth/forgot-password') ? 'forgot-container' : ''}`}>
            <main>
                <img src={logo} alt="auth logo" />
                <div className="spacing-l"></div>
                <Outlet />
            </main>
            <div className="cover"></div>
        </section>
    );
}